import { styled, useTheme } from "@mui/material";
import { useEffect, useState } from "react";

import { ChartPie } from "assets/Icon";
import { LoadingButton } from "@mui/lab";
import PortfolioPopover from "./PortfolioPopover";
import { getPortfolioChart } from "store/slices/portfolio/portfolioSlice";
import useDispatch from "hooks/useDispatch";
import { useSearchParams } from "react-router-dom";

function PortfolioChartMenu() {
  const theme = useTheme();
  const dispatch = useDispatch();

  const [searchParams] = useSearchParams();
  const walletTypeId = +searchParams.get("walletTypeId") || 1;

  const [anchorEl, setAnchorEl] = useState(null);
  const [loading, setLoading] = useState(false);

  const onOpenPortfolioPopover = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const onClose = () => {
    setAnchorEl(null);
  };

  const handleGetPortfolioDetails = async () => {
    setLoading(true);

    await dispatch(getPortfolioChart({ walletTypeId: walletTypeId }));

    setLoading(false);
  };

  useEffect(() => {
    handleGetPortfolioDetails();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [walletTypeId]);

  return (
    <>
      <LoadingButtonStyle
        loading={loading}
        disabled={loading}
        onClick={onOpenPortfolioPopover}
      >
        <ChartPie color={theme.palette.secondary.main} stroke={3} />
      </LoadingButtonStyle>

      <PortfolioPopover anchorEl={anchorEl} onClose={onClose} />
    </>
  );
}

const LoadingButtonStyle = styled(LoadingButton)(() => ({
  minHeight: "30px",
  minWidth: "30px",
}));

export default PortfolioChartMenu;
